export const SERBIA_CURRENCY_CODE = 941;
export const SERBIA_CURRENCY_ALPHA_CHAR = 'RSD';
export const TEZINA_PALETE = 20;
export const TEZINA_RAMA = 15;

export const SEF_HEALTH_CHECK_IN_SECONDS = 60;

export const KORISNICKA_PODRSKA_MOBILE: string = '+381 60/60-30-922';
export const KORISNICKA_PODRSKA_MOBILE_HREF: string = '+381606030922';
